import React, { useEffect, useState } from 'react';
import styles from './EditAccessibilityModal.module.scss';
import Modal from '../../../layout/modal/Modal';
import { closeModal, openModal } from '../../../../redux/modals/action';
import { connect } from 'react-redux';
import CustomButton from '../../../layout/customButton/CustomButton';
import {
	Button,
	Grid,
	MenuItem,
	FormControl,
	Select,
	InputLabel,
} from '@mui/material';
import { getProjectById } from '../../../../api/UserManagement/getProjectById.api';
import { getAccessibilitiesByRoles } from '../../../../redux/userManagement/actions';
import UserAccessibility from '../../roleSettingSection/userAccessibility/UserAccessibility';
import SaveNewRoleModal from './saveNewRoleModal/SaveNewRoleModal';

const EditAccessibilityModal = ({
	show,
	rolesOfAllProjects,
	accessibilities,
	closeModal,
	openModal,
	projectToEdit,
	userName,
	userId,
	getAccessibilitiesByRoles,
	projectRoles,
	setUserSelected,
	setProjectToEdit,
	setNewRole,
	accessibilitiesByRole,
	projectsList,
	setProjectsList,
}) => {
	const [projectName, setProjectName] = useState();
	const [roleChosen, setRoleChosen] = useState('');
	const [accessibilityCheckbox, setAccessibilityCheckbox] = useState({});
	const [openNewRoleModal, setOpenNewRoleModal] = useState(false);

	useEffect(() => {
		getProjectById(projectToEdit).then((data) => {
			setProjectName(data);
		});

		if (projectRoles) {
			setRoleChosen(projectRoles[projectToEdit] ?? '');
			getAccessibilitiesByRoles(
				projectToEdit,
				projectRoles[projectToEdit]
			);
		} else {
			setRoleChosen('');
			getAccessibilitiesByRoles(projectToEdit, '');
		}
	}, [projectToEdit]);

	const handleCloseModal = () => {
		setRoleChosen('');
		setProjectToEdit();
		closeModal('editAccessibility');
		openModal('addUserMgmt');
		setUserSelected(userId);
	};

	const handleConfirm = () => {
		if (roleChosen) {
			if (isAccessibilitiesChanged()) {
				setOpenNewRoleModal(true);
			} else {
				let index = projectsList.findIndex(
					(project) => project.key === projectToEdit
				);
				if (index !== -1) {
					let updatedProjectsList = JSON.parse(
						JSON.stringify(projectsList)
					);
					updatedProjectsList[index] = {
						...updatedProjectsList[index],
						role: roleChosen,
					};
					setProjectsList(updatedProjectsList);
				}
				setNewRole({ [projectToEdit]: roleChosen });
				handleCloseModal();
			}
		} else {
			setOpenNewRoleModal(true);
		}
	};

	const handleRoleChange = (e) => {
		setRoleChosen(e.target.value);
		getAccessibilitiesByRoles(projectToEdit, e.target.value);
	};

	const isAccessibilitiesChanged = () => {
		const keys1 = Object.keys(accessibilityCheckbox);
		const keys2 = Object.keys(accessibilitiesByRole);

		if (keys1.length !== keys2.length) {
			return true;
		}
		for (let key of keys1) {
			if (accessibilityCheckbox[key] !== accessibilitiesByRole[key]) {
				return true;
			}
		}
		return false;
	};

	return (
		<>
			<div className={styles.wrapper}>
				<Modal
					title={'Edit user accessibility'}
					show={show}
					close={handleCloseModal}
				>
					<Grid container className={styles.subHeader} xs={12}>
						<Grid item xs={6}>
							<div className={styles.details}>
								<div className={styles.name}>{userName}</div>
								<div className={styles.project}>
									Project: {projectName}
								</div>
							</div>
						</Grid>
						<Grid item xs={6}>
							<FormControl fullWidth>
								<InputLabel id='default-role'>
									Default role presets
								</InputLabel>
								<Select
									labelId='default-role'
									value={roleChosen}
									label='default role'
									name='default role'
									onChange={(e) => handleRoleChange(e)}
								>
									{rolesOfAllProjects
										?.filter(
											(role) =>
												role.projectCode ===
												projectToEdit
										)
										?.map((role, index) => (
											<MenuItem
												value={role.roleId}
												key={index}
											>
												{role.roleName}
											</MenuItem>
										))}
									<MenuItem value=''>None</MenuItem>
								</Select>
							</FormControl>
						</Grid>
					</Grid>
					<div className={styles.userAccessibility}>
						<div className={styles.userAccessibilitySection}>
							<UserAccessibility
								accessibilityCheckbox={accessibilityCheckbox}
								setAccessibilityCheckbox={
									setAccessibilityCheckbox
								}
							/>
							<div className={styles.actions}>
								<Button
									className={styles.cancel}
									onClick={handleCloseModal}
								>
									Cancel
								</Button>
								<CustomButton
									type={'submit'}
									width={166}
									height={42}
									onClick={handleConfirm}
								>
									Confirm
								</CustomButton>
							</div>
						</div>
					</div>
				</Modal>
			</div>
			<SaveNewRoleModal
				openNewRoleModal={openNewRoleModal}
				setOpenNewRoleModal={setOpenNewRoleModal}
				accessibilityCheckbox={accessibilityCheckbox}
				projectToEdit={projectToEdit}
				userId={userId}
				setUserSelected={setUserSelected}
				setNewRole={setNewRole}
				projectsList={projectsList}
				setProjectsList={setProjectsList}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	rolesOfAllProjects: state.userManagement.rolesOfAllProjects,
	accessibilities: state.userManagement.accessibilities,
	userName: state.userManagement.userById.fullName,
	userId: state.userManagement.userById.id,
	projectRoles: state.userManagement.userById.projectRoles,
	accessibilitiesByRole: state.userManagement.accessibilitiesByRole,
});

export default connect(mapStateToProps, {
	closeModal,
	openModal,
	getAccessibilitiesByRoles,
})(EditAccessibilityModal);
